import $ from 'jquery';
import moment from 'moment';

const momentFn = typeof moment === 'function' ? moment : moment.default;

globalThis.jQuery = $;
globalThis.$ = $;
globalThis.moment = momentFn;
